import { useState } from "react";
import { Navbar, Nav, NavItem, NavLink, Label } from "reactstrap";
import { Link } from "react-router-dom";
import NavBellIcon from "../assets/img/nav-bell.png";
import NavSettingIcon from "../assets/img/nav-setting.png";
import Image from "react-bootstrap/Image";
import "../assets/style/ToolBar.css";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch, useSelector } from "react-redux";
import {
  loginSelector,
  onLogout,
  setLocalLogout,
} from "../redux/slices/loginSlice";
import { toast } from "react-toastify";
import { LoggedUserType } from "../utils/Types";
import { API_RESPONSE_CODE, SIDE_MENU_STATUS } from "../utils/Constant";
import MenuIcon from "../assets/img/menu.svg";
import { updateSideMenuStatus } from "../redux/slices/dashboardSlice";
import { Dropdown, DropdownButton } from "react-bootstrap";

const ToolBar = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const user: LoggedUserType = useSelector(loginSelector).user;

  const updateSideMenu = () => {
    dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.OPPOSITE));
  };
  return (
    <Navbar
      color="light"
      className="navbar my-2 bg-white rounded pl-0"
      expand="md"
    >
      <div className="d-flex flex-row">
        <Image
          src={MenuIcon}
          className="menu"
          onClick={() => {
            updateSideMenu();
          }}
        />
        <div className="toolBar-welcome">Welcome,</div>
        <div className="px-2 toolBar-name">{`${
          user?.employeeName ? user?.employeeName.split(':')[0] : ""}`}</div>
      </div>
    </Navbar>
  );
};

export default ToolBar;
